import { useEffect } from "react";
import CSS from "./styles.module.css";
import { useState } from "react";

const Background = ({
	isActive,
	frostedGlass,
	background,
	children,
	vCenter,
	hCenter,
	center,
}) => {
	const [BG, setBG] = useState(false);
	const [BGexist, setBGexist] = useState(false);

	useEffect(() => {
		if (isActive) {
			setBGexist(true);
			setTimeout(() => {
				setBG(true);
			}, 20);
		} else {
			setBG(false);
			setTimeout(() => {
				setBGexist(false);
			}, 550);
		}
	}, [isActive]);

	return (
		<>
			{BGexist && (
				<div
					className={`${CSS.Background} ${BG ? CSS.BGActive : ""} ${
						frostedGlass ? CSS.FrostedBG : ""
					} ${vCenter ? CSS.vCenter : ""} ${hCenter ? CSS.hCenter : ""} ${
						center ? CSS.Center : ""
					}`}
					style={{ background: `${background}` }}
				>
					{children}
				</div>
			)}
		</>
	);
};

export default Background;
